import type { ReflectionEntry } from "@couples/shared";

import { supabase } from "../supabase";

interface EntryRow {
  id: string;
  note_id: string;
  author_id: string;
  cause: string;
  next_step: string;
  created_at: string;
}

const COLUMNS = "id, note_id, author_id, cause, next_step, created_at";

function toEntry(row: EntryRow): ReflectionEntry {
  return {
    id: row.id,
    noteId: row.note_id,
    authorId: row.author_id,
    cause: row.cause,
    nextStep: row.next_step,
    createdAt: row.created_at,
  };
}

/** couple全体ぶんの振り返りを1回で取得する。ノートごとの絞り込みは呼び出し側でグルーピングする */
export async function fetchEntries(): Promise<ReflectionEntry[]> {
  const { data, error } = await supabase.from("reflection_entries").select(COLUMNS);
  if (error) throw error;
  const rows: EntryRow[] = data;
  return rows.map(toEntry);
}

export interface EntryInput {
  noteId: string;
  cause: string;
  nextStep: string;
}

/** author_id は DB 側の既定値でセッションから埋まる */
export async function createEntry(input: EntryInput): Promise<ReflectionEntry> {
  const { data, error } = await supabase
    .from("reflection_entries")
    .insert({ note_id: input.noteId, cause: input.cause, next_step: input.nextStep })
    .select(COLUMNS)
    .single();
  if (error) throw error;
  return toEntry(data);
}

/** 消せるのは書いた本人だけ(RLS で担保) */
export async function deleteEntry(id: string): Promise<void> {
  const { error } = await supabase.from("reflection_entries").delete().eq("id", id);
  if (error) throw error;
}
